import { db } from 'services/firebase';
import { FetchResponse } from 'models';
import Mapper from 'data/Mapper';

class DataBase {
  protected collection: string;

  constructor(collection: string) {
    this.collection = collection;
  }

  getAll<T>(): Promise<FetchResponse<T[]>> {
    return db
      .collection(this.collection)
      .orderBy('date', 'desc')
      .get()
      .then((snapshot) => {
        const data: T[] = [];
        snapshot.forEach((doc) =>
          data.push(({ ...doc.data(), id: doc.id } as unknown) as T),
        );
        return Mapper.mapSuccesResponse(data);
      })
      .catch((error) => {
        return Mapper.mapError(error);
      });
  }

  add<T>(data: T): Promise<FetchResponse<{}>> {
    return db
      .collection(this.collection)
      .add(data)
      .then(() => {
        return Mapper.mapSuccesResponse({});
      })
      .catch((error) => {
        return Mapper.mapError(error);
      });
  }

  update<T>(id: string, data: T): Promise<FetchResponse<{}>> {
    return db
      .collection(this.collection)
      .doc(id)
      .update(data)
      .then(() => {
        return Mapper.mapSuccesResponse({});
      })
      .catch((error) => {
        return Mapper.mapError(error);
      });
  }

  remove(id: string): Promise<FetchResponse<{}>> {
    return db
      .collection(this.collection)
      .doc(id)
      .delete()
      .then(() => {
        return Mapper.mapSuccesResponse({});
      })
      .catch((error) => {
        return Mapper.mapError(error);
      });
  }
}

export default DataBase;
